// @flow

import { Base, Placeholder, FqdnPlaceholder } from '@gandi/ui';

import styles from './SuggestPlaceholderRow.scss';

type Props = {
  tagName?: 'li',
};

export function SuggestPlaceholderRow({ tagName }: Props): React.MixedElement {
  return (
    <Base tagName={tagName} className={styles.root}>
      <Base flex flexGrow1 flexJustifyBetween>
        <FqdnPlaceholder />
      </Base>
      <Base flex flexJustifyEnd flexAlignItemsCenter gap="xsmall">
        <Placeholder chars={10} />
      </Base>
    </Base>
  );
}
